import ShopArticlesListByCategoryResourceModel from '../../generated/types/model/resource/ShopArticlesListByCategoryResourceModel';

export default class ShopArticlesListByCategoryResourceViewModel extends ShopArticlesListByCategoryResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
